export const ONBOARDING_ROUTES = {
    SELECT_COUNTRY: '/onboarding/select-country',
    ENTER_DISPLAY_NAME: '/onboarding/enter-display-name',
    ENTER_LINK_ID: '/onboarding/enter-link-id',
    SELECT_MONEY_TYPE: '/onboarding/select-money-type',
    FIAT_CRYPTO_ONBOARDING: '/onboarding/fiat-crypto-onboarding',
    FIAT_ONBOARDING: '/onboarding/fiat-onboarding',
    CRYPTO_ONBOARDING: '/onboarding/crypto-onboarding',
};

export const AUTH_ROUTES = {
    LOGIN: '/login',
    REGISTER: '/register',
    VERIFY_EMAIL: '/verify-email',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password',
};

export const GENERAL_ROUTES = {
    HOME: '/',
    ERROR: '/error',
};

export const CHECKOUT_ROUTES = {
    CHECKOUT: '/checkout/:userId',
    COMPLETE: '/checkout/complete',
};
